/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ReleaseFlags {
    release_2504 = 'release_2504',
    release_2601 = 'release_2601',
    release_2602 = 'release_2602',
    release_2603 = 'release_2603',
    release_2604 = 'release_2604',
    release_2605 = 'release_2605',
    release_2606 = 'release_2606'
}
